const links = [
	{
		id: 'home-page',
		text: 'home',
		url: '/',
	},
	{
		id: 'about-page',
		text: 'about',
		url: '/about/',
	},
	{
		id: 'project-page',
		text: 'projects',
		url: '/projects/',
	},
	{
		id: 'contact-page',
		text: 'contact',
		url: '/contact/',
	},
	// {
	// 	id: 'blogs',
	// 	text: 'Blogs',
	// 	url: 'https://blogs.rameskum.com/',
	// 	target: '_blank',
	// },
];

export default links;
